<template>
  <nav class="ee-tabbar" :aria-label="tm('navigation', 'Navigation')">
    <span
      v-show="activeIndex !== -1"
      class="ee-tabbar__pill"
      :style="{ width: `${100 / slots.length}%`, transform: `translateX(${activeIndex * 100}%)` }"
    />
    <button
      v-for="(slot, index) in slots"
      :key="slot.key"
      type="button"
      class="ee-tab"
      :class="{ 'is-active': index === activeIndex }"
      @click="open(slot)"
    >
      <span class="material-symbols-outlined">{{ slot.icon }}</span>
      <span class="ee-tab__label">{{ slot.label }}</span>
      <span v-if="slot.badge" class="ee-tab__dot">{{ slot.badge }}</span>
    </button>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import navigateMixin from '../../mixins/navigate'
import i18nMixin from '../../modern/i18n'
import { menuIcon, pickTabs } from '../../modern/menu'

export default {
  mixins: [navigateMixin, i18nMixin],

  computed: {
    ...mapGetters({
      unreadMessagesCount: 'unreadMessagesCount',
      unreadNetworkingMessagesIds: 'unreadNetworkingMessagesIds',
    }),

    ...mapGetters('common', ['rootMenu']),

    tabs () {
      return pickTabs(this.rootMenu)
    },

    slots () {
      return [
        { key: 'home', icon: 'home', label: this.$t('layout.home'), to: '/' },
        ...this.tabs.map(item => ({
          key: item.id,
          icon: menuIcon(item),
          label: item.name,
          item,
          badge: this.badgeFor(item),
        })),
        { key: 'more', icon: 'grid_view', label: this.tm('more', 'More'), to: '/more', badge: this.moreBadge },
      ]
    },

    activeIndex () {
      const path = this.$route.path.replace(/^\/room-[^/]+/, '') || '/'
      if (path === '/') return 0
      // unknown address (the catch-all route): no tab is active
      if (this.$route.matched.some(route => route.path === '*')) return -1

      const index = this.slots.findIndex(slot => slot.item && (path === `/${slot.item.slug}` || path.startsWith(`/${slot.item.slug}/`)))
      return index === -1 ? this.slots.length - 1 : index
    },

    moreBadge () {
      const inTabs = this.tabs.map(item => item.module)
      let count = 0
      if (!inTabs.includes('messages')) count += this.unreadMessagesCount
      if (!inTabs.includes('networking')) count += this.unreadNetworkingMessagesIds.length
      return count
    },
  },

  methods: {
    badgeFor (item) {
      if (item.module === 'messages') return this.unreadMessagesCount
      if (item.module === 'networking') return this.unreadNetworkingMessagesIds.length
      return 0
    },

    open (slot) {
      this.navigateTo(slot.item || slot.to)
    },
  },
}
</script>
